import { render, staticRenderFns } from "./FormResponsesSummary.vue?vue&type=template&id=d28da5a6&scoped=true"
import script from "./FormResponsesSummary.vue?vue&type=script&lang=js"
export * from "./FormResponsesSummary.vue?vue&type=script&lang=js"
import style0 from "./FormResponsesSummary.vue?vue&type=style&index=0&id=d28da5a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28da5a6",
  null
  
)

export default component.exports